module.exports = ".centered{\n    float: none;\n    margin: 0 auto;\n}\n\n"